<template>
    <v-navigation-drawer stateless value="true" dark>
        <v-list expand>
            <template v-for="item in navigation">
                <v-list-group
                    no-action
                    :value="item.state"
                    :key="Math.random()"
                    :prepend-icon="item.icon"
                    v-if="item.items">
                    <template slot="activator">
                        <v-list-item>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </template>
                    <v-list-item v-for="subItem in item.items" :key="Math.random()" :to="subItem.url">
                        <v-list-item-action>
                            <v-icon>{{ subItem.icon }}</v-icon>
                        </v-list-item-action>

                        <v-list-item-content>
                            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-item :to="item.url" :key="Math.random()" v-else>
                    <v-list-item-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    export default {
        name: 'SEOSMMNavigation',
        data: () => ({
            navigation: [
                {
                    title: 'Главная',
                    icon: 'home',
                    url: '/'
                },
                {
                    title: 'Лояльность',
                    icon: 'account_balance_wallet',
                    url: '#',
                    items: [
                        {
                            title: 'Промо коды',
                            icon: 'card_giftcard',
                            url: '/smm/promo_code'
                        },
                        {
                            title: 'Скидки',
                            icon: 'dashboard',
                            url: '/smm/stock_catalog'
                        },
                        {
                            title: 'Бонусы за регистрацию',
                            icon: 'card_giftcard',
                            url: '/smm/stock_register'
                        },
                        {
                            title: 'Подарки на дни рождения',
                            icon: 'cake',
                            url: '/smm/birthday_bonus'
                        }
                    ]
                },
                {
                    title: 'Новости и события',
                    icon: 'dvr',
                    url: '/smm/news_events'
                },
                {
                    title: 'Отзывы',
                    icon: 'dvr',
                    url: '/smm/review'
                },
                {
                    title: 'Пуш уведомления',
                    icon: 'event',
                    url: '/smm/push'
                },
                {
                    title: 'Сообщение бота',
                    icon: 'announcement',
                    url: '/smm/tg'
                },
                {
                    title: 'Страницы',
                    icon: 'dvr',
                    url: '/smm/page'
                },
                {
                    title: 'Клиенты',
                    icon: 'supervisor_account',
                    url: '#',
                    items: [
                        {
                            title: 'Сайт, приложения',
                            icon: 'supervisor_account',
                            url: '/smm/customer'
                        },
                        {
                            title: 'Телеграм',
                            icon: 'supervisor_account',
                            url: '/smm/customer_telegram'
                        },
                    ],
                },
                {
                    title: 'Настройки',
                    icon: 'settings',
                    url: '/smm/project_settings'
                }
            ]
        }),
    }
</script>
